import { Expose } from 'class-transformer';

import { PaymentTransactionStatus } from '../../common';
import { Model } from './model';

export class PayTabsReport extends Model {
  @Expose() cartAmount: string;
  @Expose() customerEmail: string;
  @Expose() customerIP: string;
  @Expose() customerName: string;
  @Expose() customerPhone: string;
  @Expose() id: string;
  @Expose() responseStatus: PaymentTransactionStatus;
  @Expose() tranRef: string;
  @Expose() transactionId: string;
  @Expose() transactionResult: string;
}
